export { L as Languages, S as SkatteetatenLogo, d as dsI18n, l as langToLocale, r as resources } from './SkatteetatenLogo.esm.js';
export { d as getAutoCompletePropDescription, c as getCommonAutoCompleteDefault, a as getCommonButtonTypeDefault, g as getCommonClassNameDefault, b as getCommonFormVariantDefault } from './defaults.esm.js';
export { ExternalLayout } from './ExternalLayout/index.esm.js';
export { InternalLayout } from './InternalLayout/index.esm.js';
export { Separator } from './Separator/index.esm.js';
import { useState, useEffect } from 'react';
import 'react/jsx-runtime';
import 'react-i18next';
import 'i18next';

const brightnessNamesArr = [
    'light',
    'default'
];
const colorNamesArr = [
    'ochre',
    'forest',
    'burgundy',
    'denim',
    'azure',
    'graphite',
    'white',
    'black'
];
const sizeArr = [
    'extraSmall',
    'small',
    'medium',
    'large',
    'extraLarge'
];
const formArrSize = [
    sizeArr[2],
    sizeArr[3]
];
const positionArr = [
    'left',
    'right',
    'center',
    'topStart',
    'topEnd',
    'bottomStart',
    'bottomEnd'
];
const linkColorArr = [
    'white'
];
const statusArr = [
    'success',
    'neutral',
    'warning',
    'danger'
];
const headingAsArr = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const subheadingAsArr = [
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const densityArr = [
    'standard',
    'compact'
];
const weightArr = [
    'regular',
    'medium',
    'bold'
];
const spacingArr = [
    'xxs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    'mega'
];

const useMediaQuery = (query)=>{
    const [matches, setMatches] = useState(false);
    useEffect(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = ()=>{
            setMatches(media.matches);
        };
        media.addEventListener('change', listener);
        return ()=>media.removeEventListener('change', listener);
    }, [
        matches,
        query
    ]);
    return matches;
};
const useValidateFormRequiredProps = ({ required, showRequiredMark })=>{
    useEffect(()=>{
        if (!required && showRequiredMark === true) {
            console.warn(`Configuration warning: 'showRequiredMark' is set to 'true' while 'required' is '${required?.valueOf()}'. The required mark will be displayed, but the field will not be mandatory.`);
        }
    }, [
        required,
        showRequiredMark
    ]);
};

const NON_BREAKING_SPACE = '\u00A0';
const maxLengths = {
    nationalIdentityNumber: 11,
    organisationNumber: 9,
    bankAccountNumber: 11,
    phoneNumber: 10
};
const cleanInput = ({ value, type })=>{
    if ([
        'nationalIdentityNumber',
        'organisationNumber',
        'bankAccountNumber',
        'phoneNumber'
    ].includes(type)) {
        /* Seksjon for å håndtere alt annet en number-format */ let newValue = value.replace(/[^\d]/g, '');
        if (type in maxLengths) {
            newValue = newValue.substring(0, maxLengths[type]);
        }
        return {
            value: newValue
        };
    } else {
        return {
            value: ''
        };
    }
};
const insertSpaces = ({ value, positions })=>{
    let result = value;
    const strIndex = value.length;
    const pos = positions.filter((e)=>e < strIndex).sort((a, b)=>a - b);
    for (const place of [
        ...pos
    ].reverse()){
        result = `${result.slice(0, place)}${NON_BREAKING_SPACE}${result.slice(place)}`;
    }
    return result;
};
const formatGeneric = ({ value, type, positions })=>{
    let reformatted = value;
    reformatted = cleanInput({
        value: reformatted,
        type
    }).value;
    reformatted = insertSpaces({
        value: reformatted,
        positions
    });
    return {
        value: reformatted
    };
};
const formatter = ({ value, type })=>{
    if (type === 'nationalIdentityNumber') {
        return formatGeneric({
            value,
            type,
            positions: [
                6
            ]
        });
    } else if (type === 'organisationNumber') {
        return formatGeneric({
            value,
            type,
            positions: [
                3,
                6
            ]
        });
    } else if (type === 'bankAccountNumber') {
        return formatGeneric({
            value,
            type,
            positions: [
                4,
                6
            ]
        });
    } else if (type === 'phoneNumber') {
        return formatGeneric({
            value,
            type,
            positions: [
                2,
                4,
                6,
                8
            ]
        });
    }
    return {
        value: value
    };
};

export { NON_BREAKING_SPACE, brightnessNamesArr, colorNamesArr, densityArr, formArrSize, formatter, headingAsArr, linkColorArr, positionArr, sizeArr, spacingArr, statusArr, subheadingAsArr, useMediaQuery, useValidateFormRequiredProps, weightArr };
